import {ValueObject} from '@s-ui/domain'

export class SearchCodeValueObject extends ValueObject {
  /**
   * @param {String} params.searchCode
   * */
}
